module.exports = __webpack_public_path__ + "static/media/Brommer.3bdcfda9.mp3";